import React from "react";
import { Typography, Container, Paper, Box } from "@mui/material";

export default function MarketOverviewPage() {
  return (
    <Container maxWidth="lg">
      <Paper sx={{ padding: 4, marginTop: 4 }}>
        <Typography variant="h4" gutterBottom>Market Overview</Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Sector performance summary, trends, and charts
        </Typography>
        <Box>
          <Typography variant="subtitle1" color="text.secondary">
            [Demo charts or tables would appear here based on GCS long-format financial data.]
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
}